import React, { useState, useEffect } from "react";
import PasswordGenerator from "./PasswordGenerator";
// import Date from "./Date";
import { axiosInstance } from "../../axiosInstance";
import { notify } from "../../components/toastify";

import { useNavigate } from "react-router";

function AddNewCompany() {
  const [formData, setFormData] = useState({
    company_name: "",
    company_email: "",
    company_address: "",
    company_number: "",
    company_type: "",
    license_duration: "",
    password: "",
    company_logo: null,
  });
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handlePassword = (newPassword) => {
    setFormData((prevData) => ({ ...prevData, password: newPassword }));
  };

  // const handleDateChange = (year, month, day) => {
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     license_duration: `${year}-${month}-${day}`,
  //   }));
  // };

  // Set default license_duration to 30 days from today
  useEffect(() => {
    const today = new Date();
    const futureDate = new Date(today);
    futureDate.setDate(futureDate.getDate() + 30);

    const year = futureDate.getFullYear();
    const month = String(futureDate.getMonth() + 1).padStart(2, "0");
    const day = String(futureDate.getDate()).padStart(2, "0");

    const formattedDate = `${year}-${month}-${day}`;

    setFormData((prevData) => ({
      ...prevData,
      license_duration: formattedDate,
    }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }

    try {
      const response = await axiosInstance.post(
        "/api/superadmin/companies/store",
        data
      );

      notify(response.data.message, "success");
      setTimeout(() => {
        navigate("/superadmin/manage");
      }, 2000);
    } catch (error) {
      notify(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div>
        <h3 className="text-2xl font-semibold">Add New Company</h3>
        <p>Make sure to fill all necessary input</p>
      </div>
      <form onSubmit={handleSubmit} className="p-6 bg-lightgray rounded-lg ">
        <h4 className="text-xl font-semibold mb-3 text-white">
          Company Details
        </h4>
        <div className="flex flex-col lg:flex-row gap-6 flex-wrap">
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none lg:w-[48%]"
            placeholder="Company Name"
            type="text "
            name="company_name"
            // id="email"
            value={formData.company_name}
            onChange={handleChange}
            required
          />
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[48%]"
            placeholder="Youremail@mail.com"
            type="email"
            // id="email"
            name="company_email"
            value={formData.company_email}
            onChange={handleChange}
            required
          />
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[48%]"
            placeholder="Phone Number"
            type="tel"
            name="company_number"
            // id="number"
            value={formData.company_number}
            onChange={handleChange}
            // required
          />
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[48%]"
            placeholder="Company type"
            type="text"
            // id="type"
            name="company_type"
            value={formData.company_type}
            onChange={handleChange}
            // required
          />
          <input
            className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[48%]"
            placeholder="Company Address"
            type="text"
            name="company_address"
            // id="address"
            value={formData.company_address}
            onChange={handleChange}
            // required
          />
          {/* <Date onDateChange={handleDateChange} /> */}
          {/* <div className="flex flex-col lg:w-[48%] text-white">
            <label for="imageUpload" className="text-sm">
              Company Logo(if available)
            </label>
            <input
              type="file"
              // id="imageUpload"
              name="company_logo"
              accept="image/*"
              className="border border-gray-300  rounded-md lg:w-[48%]"
              onChange={handleFileChange}
            />
          </div> */}

          <PasswordGenerator onPasswordChange={handlePassword} />
        </div>

        <div className="flex justify-center mt-6 text-white font-medium text-xl p-3 bg-darkblue rounded-lg">
          <button type="submit" className="w-full h-full" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddNewCompany;
